import { signout } from 'app/infrastructure/auth/token-manager';
import { saveAsDraftBeforeLogout } from 'app/area/case/draft/save-as-draft-before-logout';

/**
 * Performs logout with draft auto-save if enabled.
 * Use this function instead of signout() directly to ensure drafts are saved.
 */
export async function logout(): Promise<void> {
  await saveAsDraftBeforeLogout();
  await signout();
}
